import template from './form.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import facturasI18N from 'i18n/facturas/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';

export let CobrarFacturaForm = {
  templateUrl: template,
  selector: 'cobrarFacturaForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(facturasI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$scope', '$filter', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', 'localStorageService', 'CustomModal'
];

function FormController($state, $scope, $filter, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, localStorageService, CustomModal) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);

  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.renderDescripcionFormaPago = renderDescripcionFormaPago.bind(this);

  this.renderCliente = renderCliente.bind(this);
  this.renderTipoComprobante = renderTipoComprobante.bind(this);
  this.renderFormaPago = renderFormaPago.bind(this);
  this.onSelectFormaPago = onSelectFormaPago.bind(this);

  this.setTotales = setTotales.bind(this);
  this.updateTotales = updateTotales.bind(this);

  this.cancel = cancel.bind(this);

  const activoFilter = Filter.path('estado.value').eq('Activo');

  const confCuotasDefectoFilter = Filter.path('codigo').eq('configuracion_cuota_defecto');
  const diasCuotasDefectoFilter = Filter.path('codigo').eq('dias_entre_cuotas_defecto');
  const numCuotasDefectoFilter = Filter.path('codigo').eq('numero_cuotas_defecto');
  const urlAbrirGavetaFilter = Filter.path('codigo').eq('url_abrir_gaveta');

  const parametroFilter = confCuotasDefectoFilter.or(diasCuotasDefectoFilter).or(numCuotasDefectoFilter).or(urlAbrirGavetaFilter);


  let unsubscribe;
  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.timbradosVigentes.reset());
    $ngRedux.dispatch(rest.actions.parametros.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    ngNotify.dismiss();
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    let caja = localStorageService.get('caja');
    if (!caja) {
      ngNotify.set(this.translations['Debe asignar una caja al equipo'], 'warn');
      $state.go('home.facturas.list');
      return;
    } else if (caja.sesionActual && caja.sesionActual.estado.value !== 'Abierta') {
      ngNotify.set(this.translations['Debe abrir la caja para cobrar'], 'warn');
      $state.go('home.facturas.list');
      return;
    }

    if ($stateParams.uid) {
      this.title = this.cuotas? this.translations['Cobro de factura a credito'] : this.translations['Cobro de factura'];
      this.formEdit('facturas', $stateParams.uid);
    } else {
      $state.go('home.facturas.list');
      return;
    }
    $ngRedux.dispatch(rest.actions.formasPago({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.marcasTarjetas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.emisoresTarjetas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.procesadorasTarjetas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));

    $timeout(function() {
      $scope.$broadcast('init');
    }, 20);
  };


  this.localModel = {
    totalServicios: $filter('currency')(0, 'Gs.', 0),
    totalProductos: $filter('currency')(0, 'Gs.', 0),
    total: $filter('currency')(0, 'Gs.', 0),
    detalles: [],
    nuevoDetalle: {},
    totalDetalles: 0,
    vuelto: 0,
    montoCuotas: $filter('currency')(0, 'Gs.', 0)
  };

  this.payloadCuotas = {
    montoCuotas: 0,
    cantidadCuotas: 1,
    diasEntreCuotas: 30
  };

  this.submitted = false;

  function mapStateToThis(state) {
    this.handleStatus(state);

    this.model = state.form.model;

    if (!this.modelInit && this.model.id) {
      this.modelInit = true;
      this.setTotales();
      this.localModel.timbradoDetalle = this.renderTipoComprobante(this.model.timbradoDetalle, this.model.tipoComprobante);
      this.localModel.cliente = this.renderCliente(this.model.cliente);
      this.cuotas = this.model.tipoComprobante.generaCuotas;
      if (this.cuotas) {
        this.title = this.translations['Cobro de factura a credito'];
      }
      this.actualizarMontoCuotas();
    }

    if (state.formasPago.data.length && !this.formaPagoDefault) {
      this.formaPagoDefault = state.formasPago.data.filter(v => v.formaDesembolso.value === 'Efectivo')[0];
      this.localModel.nuevoDetalle.formaPago = this.formaPagoDefault;
    }

    this.procesadorasTarjetas = state.procesadorasTarjetas.data;

    if (this.model.formaPagoDescuento && !this.formaPagoDescuentoInit) {
      this.formaPagoDescuentoInit = true;
      this.formaPagoDefault = this.model.formaPagoDescuento;
      this.localModel.nuevoDetalle.formaPago = this.formaPagoDefault;
      if (!this.procesadorasTarjetasFiltradas) {
        this.filterProcesadora();
      }
    }

    if (state.parametros.data && state.parametros.data.length) {

      let confCuotasDefecto = state.parametros.data.filter((v) => v.codigo === 'configuracion_cuota_defecto')[0];
      if (confCuotasDefecto && confCuotasDefecto.valor.value == 'SI') {
        console.log(confCuotasDefecto);
        this.confCuotasDefecto = true;
      } else {
        console.log(confCuotasDefecto);
        this.confCuotasDefecto = false;
      }

      let diasCuotasDefecto = state.parametros.data.filter((v) => v.codigo === 'dias_entre_cuotas_defecto')[0];
      if (this.confCuotasDefecto && diasCuotasDefecto && diasCuotasDefecto.valor.value) {
        this.payloadCuotas.diasEntreCuotas = Number.parseInt(diasCuotasDefecto.valor.value);
      } else {
        this.payloadCuotas.diasEntreCuotas = 30;
      }

      let numCuotasDefectoFilter = state.parametros.data.filter((v) => v.codigo === 'numero_cuotas_defecto')[0];

      if (this.confCuotasDefecto && numCuotasDefectoFilter && numCuotasDefectoFilter.valor.value) {
        this.payloadCuotas.cantidadCuotas = Number.parseInt(numCuotasDefectoFilter.valor.value);
        this.actualizarMontoCuotas();
      } else {
        this.payloadCuotas.cantidadCuotas = 1;
      }

    }

    return {
      form: state.form,
      formasPago: state.formasPago.data,
      marcasTarjetas: state.marcasTarjetas.data,
      emisoresTarjetas: state.emisoresTarjetas.data,
      urlAbrirGaveta: state.parametros.data.filter((v) => v.codigo === 'url_abrir_gaveta')[0]
    };
  }

  function setTotales() {
    let totalServicios = 0;
    let totalProductos = 0;

    this.model.detalles.forEach(function(detalle) {
      let descuento = detalle.descuento ? detalle.descuento : 0;
      if (detalle.producto) {
        totalProductos += detalle.precio - descuento;
      } else {
        totalServicios += detalle.precio - descuento;
      }
    });
    this.localModel.totalServicios = $filter('currency')(totalServicios, 'Gs.', 0);
    this.localModel.totalProductos = $filter('currency')(totalProductos, 'Gs.', 0);

    if (this.model.descuento) {
      this.model.total = this.model.total;
    }

    this.localModel.total = $filter('currency')(this.model.total, 'Gs.', 0);
    this.localModel.descuento = $filter('currency')(this.model.descuento, 'Gs.', 0);

    this.updateTotales();
    let montoRestante = this.localModel.restante && this.localModel.restante > 0? this.localModel.restante : null;
    if (montoRestante && this.model && this.model.tipoComprobante && this.model.tipoComprobante.generaCuotas) {
      montoRestante = Math.round(montoRestante*60/100);
    }
    this.localModel.nuevoDetalle.monto = montoRestante;
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.facturas.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      this.cobrarFacturaNotify(state.form.created);
      $state.go('home.facturas.list');
    }
  }

  function doSubmit() {
    let self = this;

    // Checks
    if (!this.cuotas && this.localModel.totalDetalles < this.model.total) {
      ngNotify.set(this.translations['Total detalles no cubre la factura'], 'warn');
      return;
    }
    if (this.cuotas && this.localModel.detalles.length && !this.localModel.numeroReciboEntregaInicial) {
      ngNotify.set(this.translations['Debe ingresar número de recibo de la entrega inicial'], 'warn');
      return;
    }

    // Si esta configurada la URL para abrir la gaveta, intentamos abrirla
    if (this.urlAbrirGaveta && this.urlAbrirGaveta.valor && this.urlAbrirGaveta.valor.value) {
      const urlAbrirGaveta = this.urlAbrirGaveta && this.urlAbrirGaveta.valor && this.urlAbrirGaveta.valor.value;
      fetch(urlAbrirGaveta)
        .then(function(response) {
          if(response.ok) {
            // Si se pudo abrir con exito, proceder al cobro
            self.confirmDoSubmit();
          } else {
            // En caso de error al abrir, preguntar si se desea guardar el cobro de todos modos
            self.errorGavetaConfirmacion();
          }
        })
        .catch(function(error) {
          // En caso de error al abrir, preguntar si se desea guardar el cobro de todos modos
          self.errorGavetaConfirmacion();
        });
    } else {
      // Si no estaba configurada URL de gaveta, procedemos al guardado normal del cobro
      self.confirmDoSubmit();
    }
  }

  this.errorGavetaConfirmacion = errorGavetaConfirmacion.bind(this);
  function errorGavetaConfirmacion() {
    let self = this;
    CustomModal.open({
      title: 'No se pudo habilitar la caja registradora',
      message: '¿Desea continuar la operación?',
      ok: function() {
        self.confirmDoSubmit();
      }
    });
  }

  this.confirmDoSubmit = confirmDoSubmit.bind(this);
  function confirmDoSubmit() {
    let pagos = Object.assign([], this.localModel.detalles);
    let vuelto = this.localModel.vuelto;

    if (vuelto) {
      // Por cada pago
      pagos.forEach(function(detalle) {
        // Si es en efectivo, y sigue habiendo vuelto que descontar
        if (detalle.formaPago.formaDesembolso.value === 'Efectivo' && vuelto > 0) {
          let diff = detalle.monto - vuelto;
          if (diff === 0) {
            // Si la cantidad restante de vuelto cubre justo el monto de este detalle, se anulan
            vuelto = 0;
            detalle.monto = 0;
          } else if (diff < 0) {
            // Si el vuelto restante es mayor al monto de este detalle
            // se descuenta del vuelto restante la cantidad del monto del detalle
            vuelto = -diff;
            // se cancela el monto del detalle
            detalle.monto = 0;
          } else {
            // Si el monto del detalle es mayor
            // se descuenta del monto del detalle, lo que quedaba del vuelto
            detalle.monto = diff;
            // se cancela el vuelto
            vuelto = 0;
          }
        }
      });
      // Filtrar solo los pagos que no quedaron anulados
      pagos = pagos.filter((detalle)=>{return detalle.monto > 0;});
    }

    let caja = localStorageService.get('caja');
    let payload = {
      pagos,
      numeroReciboEntregaInicial: this.localModel.numeroReciboEntregaInicial,
      sesionCajaId: caja.sesionActual.id
    };

    if (this.localModel.vuelto && this.mostrarConceptoNoFacturado) {
      payload.tipoTransaccionId = this.localModel.tipoTransaccion.id;
      payload.conceptoNoFacturado = vuelto;
    }

    if (this.cuotas) {
      payload.generaCuotas = true;
      payload.montoCuotas = this.payloadCuotas.montoCuotas;
      payload.cantidadCuotas = this.payloadCuotas.cantidadCuotas;
      payload.diasEntreCuotas = this.payloadCuotas.diasEntreCuotas;
    }

    let self = this;
    $ngRedux.dispatch(rest.actions.cobrarFactura({ id: this.model.id }, {
      body: JSON.stringify(payload)
    }, (err, data) => {
      if (!err && (data.estado.value == 'Cobrada' || (data.estado.value == 'Saldo Pendiente' && this.cuotas) ) ) {
        ngNotify.set(self.translations['Cobrada Correctamente'], 'success');
        if (!data.periodoNomina) {
          ngNotify.set('Cobrada Correctamente (No existe periodo de nómina)', 'warn');
        }
        $state.go('home.facturas.list');
      } else if (err) {
        ngNotify.set(formatErrorMessage(err.message), { type: 'error', html: true });
      }
    }));
  }

  function updateTotales() {
    let totalEfectivo = 0;
    let totalOtros = 0;

    this.localModel.detalles.forEach(function(detalle) {
      if (detalle.formaPago.formaDesembolso.value === 'Efectivo') {
        totalEfectivo += detalle.monto;
      } else {
        totalOtros += detalle.monto;
      }
    });

    this.localModel.totalDetalles = totalEfectivo + totalOtros;
    let diff = this.localModel.totalDetalles - this.model.total;
    this.localModel.vuelto = diff > 0? diff : 0;
    this.localModel.restante = this.model.total - this.localModel.totalDetalles;
  }

  this.filterProcesadora = filterProcesadora.bind(this);

  function filterProcesadora() {
    if (!this.procesadorasTarjetas)
      return;

    let formaPagoSeleccionadaId = this.localModel.nuevoDetalle.formaPago.id;
    this.procesadorasTarjetasFiltradas = this.procesadorasTarjetas.filter(v => v.formaPago && v.formaPago.id === formaPagoSeleccionadaId);
  }

  function onSelectFormaPago() {
    $scope.form.$setUntouched();
    if (this.localModel.nuevoDetalle.formaPago && this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Efectivo') {
      let montoRestante = this.localModel.restante && this.localModel.restante > 0? this.localModel.restante : null;
      if (montoRestante && this.model && this.model.tipoComprobante && this.model.tipoComprobante.generaCuotas) {
        montoRestante = Math.round(montoRestante*60/100);
      }
      this.localModel.nuevoDetalle.monto = montoRestante;
      //this.localModel.nuevoDetalle.montoView = this.localModel.total;
    }

    if (this.localModel.nuevoDetalle.formaPago && (this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Tarjeta de crédito' &&
        this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Tarjeta de débito')) {
      this.localModel.nuevoDetalle.procesadoraTarjeta = null;
      this.localModel.nuevoDetalle.emisorTarjeta = null;
      this.localModel.nuevoDetalle.marcaTarjeta = null;
    }
    this.filterProcesadora();
    //  if (vm.localModel.nuevoDetalle.formaPago && vm.localModel.nuevoDetalle.formaPago.)
  }

  function newDetalle() {
    this.detalleSubmitted = true;
    $scope.form.importe.$setValidity('custom', true);
    $scope.form.importe.$setTouched();
    if (!$scope.form.$valid) {
      return;
    }

    if (this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Efectivo' &&
      (this.localModel.nuevoDetalle.monto + this.localModel.totalDetalles) > this.model.total) {
      this.mostrarConceptoNoFacturado = true;
    }

    let detalle = Object.assign({}, this.localModel.nuevoDetalle);
    this.localModel.detalles.push(detalle);
    this.localModel.nuevoDetalle = {
      formaPago: this.formaPagoDefault
    };
    this.detalleSubmitted = false;
    this.updateTotales();
    let montoRestante = this.localModel.restante && this.localModel.restante > 0? this.localModel.restante : null;
    if (montoRestante && this.model && this.model.tipoComprobante && this.model.tipoComprobante.generaCuotas) {
      montoRestante = Math.round(montoRestante*60/100);
    }
    this.localModel.nuevoDetalle.monto = montoRestante;
    this.actualizarMontoCuotas();
    $scope.form.$setUntouched();
  }

  function deleteDetalle(detalle) {
    _.remove(this.localModel.detalles, detalle);
    this.updateTotales();
    let montoRestante = this.localModel.restante && this.localModel.restante > 0? this.localModel.restante : null;
    if (montoRestante && this.model && this.model.tipoComprobante && this.model.tipoComprobante.generaCuotas) {
      montoRestante = Math.round(montoRestante*60/100);
    }
    this.localModel.nuevoDetalle.monto = montoRestante;
  }

  function renderDescripcionFormaPago(detalle) {
    let descripcion = detalle.formaPago.descripcion;
    if (detalle.formaPago.formaDesembolso.value === 'Tarjeta de crédito' || detalle.formaPago.formaDesembolso.value === 'Tarjeta de débito') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name}/${detalle.procesadoraTarjeta.nombre}${detalle.emisorTarjeta ? '/' + detalle.emisorTarjeta.nombre: ''}${detalle.marcaTarjeta ? '/' + detalle.marcaTarjeta.nombre: ''}/${detalle.numeroVoucher})`;
    } else if (detalle.formaPago.formaDesembolso.value === 'Cheque') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name}${detalle.chequeEntidadBancaria ? '/' + detalle.chequeEntidadBancaria: ''}/${detalle.chequeNumero}${detalle.chequeNumeroCuenta ? '/' + detalle.chequeNumeroCuenta : ''})`;
    } else if (detalle.formaPago.formaDesembolso.value === 'Efectivo') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name})`;
    }
    return descripcion;
  }

  function renderFormaPago(formaPago) {
    return `${formaPago.descripcion} (${formaPago.formaDesembolso.name})`;
  }

  function renderTipoComprobante(timbradoDetalle, tipoComprobante) {
    return `${tipoComprobante.nombre} (${tipoComprobante.clase.name} / ${timbradoDetalle.cabecera.claseTimbrado.name} )`;
  }

  function renderCliente(cliente) {
    let numeroDoc = cliente.numeroDocumento ? cliente.numeroDocumento : 'Sin Nro. Documento';
    return `${cliente.razonSocial} (${numeroDoc})`;
  }

  function cancel() {
    $state.go('home.facturas.list');
  }


  this.loadTipoFondoFijos = loadTipoFondoFijos.bind(this);


  function loadTipoFondoFijos(query) {
    let filter = Filter.path('tipoMovimiento.value').eq('Concepto no Facturado');

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('tipos-movimientos-fondos-fijos');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.renderTipoFondoFijo = renderTipoFondoFijo.bind(this);


  function renderTipoFondoFijo(tipoFondoFijo) {
    return `${tipoFondoFijo.nombre}`;
  }

  this.actualizarMontoCuotas = actualizarMontoCuotas.bind(this);

  function actualizarMontoCuotas() {
    let entregaInicial = 0;
    console.log('totalDetalles: '+this.localModel.totalDetalles);
    console.log('totalDetalles.length: '+this.localModel.totalDetalles.length);
    if (this.localModel.totalDetalles) {
      entregaInicial = this.localModel.totalDetalles;
    }
    let cantidadCuotas = this.payloadCuotas.cantidadCuotas;
    console.log('entrega inicial: '+entregaInicial);
    console.log('cantidad cuotas: '+cantidadCuotas);
    console.log('total factura: '+this.model.total);
    this.payloadCuotas.montoCuotas = Math.ceil((this.model.total - entregaInicial) / cantidadCuotas);
    this.localModel.montoCuotas = $filter('currency')(this.payloadCuotas.montoCuotas, 'Gs.', 0);

    console.log('monto cuotas: '+this.payloadCuotas.montoCuotas);
  }

  this.getImporteMax = getImporteMax.bind(this);

  function getImporteMax() {
    return Math.round(this.model.total*60/100);
  }
}



// WEBPACK FOOTER //
// ./src/components/facturas/cobrar/form.component.js